import React, { useState, useEffect, useRef } from "react";
import { twMerge } from "tailwind-merge";

interface BlackToastProps {
  message: string;
  className?: string;
  duration?: number; // Optional: time message stays visible, default to 3000ms
}

const BlackToast: React.FC<BlackToastProps> = ({
  message,
  className,
  duration = 3000,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const toastRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      setIsFadingOut(false); //Reset fade out state

      const timer = setTimeout(() => {
        setIsFadingOut(true);
      }, duration);

      const fadeOutTimer = setTimeout(() => {
        setIsVisible(false);
      }, duration + 200); //200 is for animation duration, must be same as css transition duration

      return () => {
        clearTimeout(timer);
        clearTimeout(fadeOutTimer);
      };
    }
    return undefined;
  }, [message, duration]);

  if (!message) return null;

  return (
    <div className="fixed bottom-5 left-1/2 transform -translate-x-1/2 z-50 pointer-events-none">
      <div
        ref={toastRef}
        className={twMerge(
          `transition-opacity duration-200 ease-in-out ${
            isVisible
              ? isFadingOut
                ? "opacity-0"
                : "opacity-100"
              : "opacity-0"
          }`, // Apply transition
          "flex justify-center items-center px-[24px] py-[15px] gap-[10px] h-[52px] bg-[#232323] [box-shadow:0px_0px_20px_rgba(0,_0,_0,_0.08)] rounded-[8px] font-semibold text-base leading-[140%] text-center text-[#FFFFFF]",
          className
        )}
      >
        {message}
      </div>
    </div>
  );
};

export default BlackToast;
